/**
 * @file ClientSpecificationsTab.js
 * @description Client Specifications tab component for the Client SSO Wizard.
 */

import React, { useState, useEffect } from 'react';
import SSOAttributeValueDropdown from '../../shared/asyncDropdowns/SSOAttributeValueDropdown';
import AttributeTable from '../components/AttributeTable';
import style from '../sso.module.scss';
import NotFoundBox from '../../ui/no_data_indicators/NotFoundBox';
import { getText } from '../../../i18n';

const ClientSpecificationsTab = ({
    data,
    onChange,
    isSSSelected,
    onSave,
    isClientSSOReadOnly,
    shouldShowSharedWithAdditionalUsers
}) => {
    const [formData, setFormData] = useState({
        nameId: data.nameId || '',
        tenantSSOAttributes: data.tenantSSOAttributes || [],
    });

    useEffect(() => {
        setFormData({
            nameId: data.nameId || '',
            tenantSSOAttributes: data.tenantSSOAttributes || [],
        });
    }, [data]);

    if (!isSSSelected) {
        return (
            <NotFoundBox
                backgroundColor="#f0f4ff"
                title={getText('msg_7cc6a6e8c21a')}
                description={getText('msg_b1bffadaa58e')}
            />
        );
    }

    const handleNameIdChange = value => {
        setFormData(prevData => {
            const newData = {
                ...prevData,
                nameId: value,
            };
            onChange(newData);
            return newData;
        });
    };

    const handleAttributesChange = attributes => {
        setFormData(prevData => {
            const newData = {
                ...prevData,
                tenantSSOAttributes: attributes,
            };
            onChange(newData);
            return newData;
        });
    };

    return (
        <div
            className={`col-12 col-xs-12 col-md-12 col-lg-12 m-auto pb-5 px-5 ${style.AttributesTabContainer}`}
        >
            <div className="col-12 col-lg-4 form-group mb-4">
                <SSOAttributeValueDropdown
                    selectedAttributeValue={formData.nameId}
                    onAttributeValueChange={handleNameIdChange}
                    inlineLabel={false}
                    isRequired={false}
                    isReadOnly={true}
                    isDisabled={true}
                    placeholder={getText('msg_1bbac8839e6c')}
                    label={getText('msg_1bbac8839e6c')}
                />
            </div>

            <AttributeTable
                attributes={formData.tenantSSOAttributes}
                onChange={handleAttributesChange}
                isClient={true}
                readOnly={isClientSSOReadOnly}
            />

            <div className="d-flex justify-content-between mt-4 pt-4 col-12 col-sm-5 m-auto">
                <p>
                    <span className="text-danger">*</span> {getText('msg_7c118f042eaa')}
                </p>
                {((shouldShowSharedWithAdditionalUsers && isClientSSOReadOnly) || !isClientSSOReadOnly) && (
                    <button
                        type="button"
                        className="button-base ing-button-primary-left"
                        onClick={onSave}
                    >
                        {getText('msg_efc007a393f6')}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ClientSpecificationsTab;
